import "./BucketToggle.css";

/**
 * Phase 18 WU-18.E1 — shared bucket (day/week/month) toggle for AnalyticsPage.
 * Default resolution lives in `resolveDefaultBucket` so pages can seed state.
 */
export type Bucket = "day" | "week" | "month";

const OPTIONS: { value: Bucket; label: string }[] = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

export interface BucketToggleProps {
  value: Bucket;
  onChange: (bucket: Bucket) => void;
  /** Inclusive range span in days — used only for a default helper. */
  rangeDays?: number;
}

/**
 * WU-18.C tier auto-routing: ranges > 90 days fall to monthly rollups.
 * We surface that by defaulting the bucket to "month" when the range
 * exceeds 90 days so the UI matches the backend tier up-front.
 */
export function resolveDefaultBucket(rangeDays: number): Bucket {
  return rangeDays > 90 ? "month" : "day";
}

export function BucketToggle({ value, onChange }: BucketToggleProps) {
  return (
    <div
      className="bucket-toggle"
      role="radiogroup"
      aria-label="Bucket granularity"
    >
      {OPTIONS.map((o) => {
        const selected = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={o.label}
            className={`bucket-toggle__opt${selected ? " bucket-toggle__opt--selected" : ""}`}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
